import React from 'react';
import styles from './AwairLogo.module.scss';
import classNames from 'classnames/bind';

import AwairLogoImage from '../../../assets/images/awair-logo.png';

const cx = classNames.bind(styles);

const AwairLogo = ({className}) => {
  return (
    <img className={`${cx('AwairLogo')} ${className}`} src={AwairLogoImage} alt="Awair Logo" />
  );
};

export default AwairLogo;